// extracted by mini-css-extract-plugin
export default {"section":"style_section__bLW7+","description":"style_description__BZDdG","content":"style_content__YuA3W","svg":"style_svg__vaemh"};